import CustomLoading from '@/shahrzad-assets/shared_components/CustomLoading'
import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { AuthRoutes } from './Routes'

const AuthRouting = () => {
  return (
    <>
      <Routes>
        {AuthRoutes?.map((route, index) =>
          route.layout ? (
            <Route
              key={index}
              path={route.path}
              element={
                <Suspense fallback={<CustomLoading />}>
                  <route.layout {...route}>
                    <route.component />
                  </route.layout>
                </Suspense>
              }
            />
          ) : (
            <Route
              key={index}
              path={route.path}
              element={
                <Suspense fallback={<CustomLoading />}>
                  <route.component />
                </Suspense>
              }
            ></Route>
          ),
        )}
      </Routes>
    </>
  )
}

export default AuthRouting
